import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-606ec466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row justify-center" }
const _hoisted_3 = { class: "flex flex-col w-full sm:w-1/5 text-center p-3 sm:p-1 justify-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Your wallet", -1))
const _hoisted_5 = { class: "text-4xl bsl-red-gradient" }
const _hoisted_6 = { class: "flex flex-col w-full sm:w-1/5 text-center p-3 sm:p-1 justify-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Smiths staked", -1))
const _hoisted_8 = { class: "text-4xl bsl-blue-gradient" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.farmerAcc?.identity.toBase58().substring(0, 4) + '....' +
          _ctx.farmerAcc?.identity.toBase58().slice(-4)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.farmerAcc?.gemsStaked), 1)
      ]),
      (_openBlock(), _createBlock(_component_FarmerRewardDisplay, {
        key: _ctx.farmerAcc?.rewardA,
        farmReward: _ctx.farmAcc?.rewardA,
        reward: _ctx.farmerAcc?.rewardA,
        gems: _ctx.farmerAcc?.gemsStaked,
        title: "Reward"
      }, null, 8, ["farmReward", "reward", "gems"]))
    ])
  ]))
}